import { render, staticRenderFns } from "./PopupWriteDefaultLayout.vue?vue&type=template&id=a1ec63e6&scoped=true&"
import script from "./PopupWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PopupWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ec63e6",
  null
  
)

export default component.exports